export const shouldRemove = (_) => !_.visible;

export const getPathAt = (path, index) => path.split('.')[index];

export const shouldAddSortOrder = (member) =>
  member && typeof member.sortOrder === 'number';

export const belongToADifferentCategory = (categoryPath, memberPath) =>
  categoryPath !== getPathAt(memberPath, 0);

export const isFunctionParam = (param) =>
  param.metaData && param.metaData.type === 'FUNCTION';

export const isFirstLevelMember = (memberPath) =>
  memberPath.split('.').length === 2;

export const shouldMoveMemberToTheCurrentCategory = (
  categoryPath,
  memberPath,
) =>
  belongToADifferentCategory(categoryPath, memberPath) &&
  isFirstLevelMember(memberPath);
